import { combineReducers } from "redux";
import { default as session } from 'state/app/SessionReducers';

export default combineReducers({
  session
});
